import apiSlice from "./api/api";
import {
  ATT_FIRST_IN_LAST_OUT,
  ATT_TIME_CARD,
  ATT_DAILY,
  ATT_SUMMARY,
  ATT_DETAILS,
  ATT_EMPLOYEE,
  ATT_ADD_EXCEPTION
} from "./ENDPOINTS";

const attendanceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get daily attendance report (V2)
    getDailyAttendance: builder.query({
      query: ({ start_date, end_date, branch_id, department_id, format }) => {
        const params = new URLSearchParams();
        if (start_date) params.append('start_date', start_date);
        if (end_date) params.append('end_date', end_date);
        if (branch_id) params.append('branch_id', branch_id);
        if (department_id) params.append('department_id', department_id);
        if (format) params.append('format', format);

        return {
          url: `${ATT_DAILY}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Attendance"],
    }),

    // Get first-in/last-out report (V2)
    getFirstInLastOut: builder.query({
      query: ({ start_date, end_date, branch_id, department_id, format }) => {
        const params = new URLSearchParams();
        if (start_date) params.append('start_date', start_date);
        if (end_date) params.append('end_date', end_date);
        if (branch_id) params.append('branch_id', branch_id);
        if (department_id) params.append('department_id', department_id);
        if (format) params.append('format', format);

        return {
          url: `${ATT_FIRST_IN_LAST_OUT}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Attendance"],
    }),

    // Get time card report (V2)
    getTimeCard: builder.query({
      query: ({ start_date, end_date, branch_id, department_id, format }) => {
        const params = new URLSearchParams();
        if (start_date) params.append('start_date', start_date);
        if (end_date) params.append('end_date', end_date);
        if (branch_id) params.append('branch_id', branch_id);
        if (department_id) params.append('department_id', department_id);
        if (format) params.append('format', format);

        return {
          url: `${ATT_TIME_CARD}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Attendance"],
    }),

    // Get attendance summary report (V2)
    getAttendanceSummary: builder.query({
      query: ({ start_date, end_date, branch_id, department_id, format }) => {
        const params = new URLSearchParams();
        if (start_date) params.append('start_date', start_date);
        if (end_date) params.append('end_date', end_date);
        if (branch_id) params.append('branch_id', branch_id);
        if (department_id) params.append('department_id', department_id);
        if (format) params.append('format', format);

        return {
          url: `${ATT_SUMMARY}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["AttendanceSummary"],
    }),

    // Get attendance details for specific date (V1)
    getAttendanceDetails: builder.query({
      query: ({ employee_id, date }) => {
        const params = new URLSearchParams();
        if (employee_id) params.append('employee_id', employee_id);
        if (date) params.append('date', date);

        return {
          url: `${ATT_DETAILS}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Attendance"],
    }),

    // Get employee attendance (V1)
    getEmployeeAttendance: builder.query({
      query: ({ employee_id, start_date, end_date }) => {
        const params = new URLSearchParams();
        if (employee_id) params.append('employee_id', employee_id);
        if (start_date) params.append('start_date', start_date);
        if (end_date) params.append('end_date', end_date);

        return {
          url: `${ATT_EMPLOYEE}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Attendance"],
    }),

    // Add attendance exception (V1)
    addAttendanceException: builder.mutation({
      query: (data) => ({
        url: ATT_ADD_EXCEPTION,
        method: "POST",
        body: data
      }),
      invalidatesTags: ["Attendance", "AttendanceSummary"],
    }),
  })
});

export const {
  useLazyGetDailyAttendanceQuery,
  useLazyGetFirstInLastOutQuery,
  useLazyGetTimeCardQuery,
  useLazyGetAttendanceSummaryQuery,
  useLazyGetAttendanceDetailsQuery,
  useLazyGetEmployeeAttendanceQuery,
  useAddAttendanceExceptionMutation,
} = attendanceApiSlice;
